import { Subscribe } from 'unstated';

import ConfirmDialog from '~/components/ConfirmDialog';
import EnrichmentSidebar from '~/components/EnrichmentSidebar';
import TrashcanIcon from '~/components/icons/TrashcanIcon';
import Sidebar, {
  SidebarContent,
  SidebarSubtitle,
  SidebarTitle,
} from '~/components/Sidebar';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '~/components/Table';
import Tooltip from '~/components/Tooltip';
import ConfirmDialogContainer from '~/containers/ConfirmDialog';

import styles from './ShowResponse.style';
import Timestamp from './Timestamp';

const RiskRow = ({ classes }) => (
  <TableRow key="risk">
    <TableCell sub small slim className={classes.risky}>
      Risk Level
    </TableCell>
    <TableCell className={classes.risky}>
      <div className={classes.tooltipContainer}>
        High
        <Tooltip
          title="We detected this submission looked spammy. e.g. using a disposable email address or proxy server."
          placement="bottom-start"
          tooltipStyles={{ visibility: 'show' }}
        />
      </div>
    </TableCell>
  </TableRow>
);

class ShowResponse extends React.Component {
  renderValue = (key) => {
    const {
      response: { values },
    } = this.props;

    return (
      <TableRow key={key}>
        <TableCell sub small slim title={key} ellipsis>
          {key}
        </TableCell>
        <TableCell title={values[key]}>{values[key]}</TableCell>
      </TableRow>
    );
  };

  continueDeletion = () => {
    const { response, deleteResponse, closeDrawer } = this.props;

    deleteResponse(response.id).then(() => {
      return closeDrawer();
    });
  };

  handleTrashcanClick = () => {
    const {
      confirmDialogContainer: { showConfirmDialog },
    } = this.props;

    showConfirmDialog({
      title: 'Are your sure you want to delete this response?',
      confirm: this.continueDeletion,
    });
  };

  render() {
    const { response, classes } = this.props;

    return (
      <div className={classes.root}>
        <Sidebar className={classes.response}>
          <div>
            <SidebarTitle>
              <div className={classes.responseTitleBar}>
                Response
                <TrashcanIcon
                  className={classes.deleteResponse}
                  onClick={() => this.handleTrashcanClick()}
                />
              </div>
            </SidebarTitle>
            <SidebarSubtitle>
              <Timestamp dateTime={response.submitted_at} />
            </SidebarSubtitle>
          </div>

          <SidebarContent>
            <Table sidebar>
              <TableHead>
                <TableRow>
                  <TableCell slim small>
                    Name
                  </TableCell>
                  <TableCell>Value</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {Object.keys(response.values).map(this.renderValue)}
                {response.risk_level === 'high' && (
                  <RiskRow classes={classes} />
                )}
              </TableBody>
            </Table>
          </SidebarContent>
        </Sidebar>

        {(response.person_name || response.company_name) && (
          <EnrichmentSidebar response={response} />
        )}

        <ConfirmDialog />
      </div>
    );
  }
}

const WrappedShowResponse = (props) => (
  <Subscribe to={[ConfirmDialogContainer]}>
    {(confirmDialogContainer) => (
      <ShowResponse
        confirmDialogContainer={confirmDialogContainer}
        {...props}
      />
    )}
  </Subscribe>
);

ShowResponse.propTypes = {
  classes: PropTypes.object.isRequired,
  response: PropTypes.object.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  deleteResponse: PropTypes.func.isRequired,
};

export default withStyles(styles)(WrappedShowResponse);
